/* eslint-disable jsx-a11y/alt-text */
import React from 'react';
import { useSelector } from 'react-redux';
import { ReactComponent as LogoDark } from './logo.svg';
import { ReactComponent as LogoColor } from './logo-color.svg';
import { ReactComponent as IProfileLogo } from './iprofile-logo.svg';
import IProfileCertLogo from './iprofile-lmi-logo.png';
import themes from '../../shared/style/themes/themes';

import { appThemeSelector } from '../App/AppSelectors';

LogoDark.defaultProps = { height: '100%' };
LogoColor.defaultProps = { height: '100%' };
IProfileLogo.defaultProps = { height: '100%' };

const Logo = ({ width, height, type }) => {
  const appTheme = useSelector(appThemeSelector);

  if (appTheme === themes.iprofile) {
    if (type === 'certificate') {
      return <img src={IProfileCertLogo} width={width} height={height} alt="cpd-cert-logo" />;
    }
    return <IProfileLogo width={width} height={height} />;
  }
  return <LogoColor width={width} height={height} />;
};

export default Logo;
